<template>
  <div class="mobile-partner-box">
    <div class="mobile-en-title">COOPERATIVE PARTNER</div>
    <div class="mobile-cn-title">合作伙伴</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.mobile-partner-box {
  width: 100%;
  height: 82.25rem;
  background: url("~@/assets/mobile/home/partner.png") center center no-repeat;
  background-size: contain;
  padding: 12.5rem 0 0 3.75rem;
}

.mobile-partner-box .mobile-en-title {
  margin-bottom: 2rem;
  font-weight: 500;
  font-size: 1.75rem;
  color: #e3b281;
}

.mobile-partner-box .mobile-cn-title {
  margin-bottom: 2rem;
  font-weight: 500;
  font-size: 2.75rem;
  color: #e3b281;
}
</style>
